import React, { useState, useEffect, useRef, useCallback, useLayoutEffect, Ref } from "react";
import history from "../history";
import { useSignal, useSlot } from 'react-signal-slot';
import PopupLoadPictures from "../Common/PopupLoadPictures/PopupLoadPictures";
import PopupLoadVideo from '../Common/PopupLoadVideo/PopupLoadVideo';
import ListPicturesLoader from "../Common/ListPicturesLoader/ListPicturesLoader";

import UserDetailsTable from "../Admin/UserDetailsTable";

import ConfirmPopup from "../Common/ConfirmPopup/ConfirmPopup";
import NotificationPopup from "../Common/NotificationPopup/NotificationPopup";

import PersonalDataTable from "../Tables/PersonalDataTable";

//import DocumentsTable from "../Profile/Documents/DocumentsTable";

import { ApplicationDetailsWrapper } from "../TradeApplication/components/ApplicationDetailsWrapper";

import Popup from "../Popups/Popup";
import FormPopup from "../Popups/FormPopup";
import ApplicationPopup from "../Popups/ApplicationPopup";
import PictureCropPopup from "../Popups/PictureCropPopup";

import Input from "../FormUi/Input";
import Loading from "../Ui/Loading";

import useForm from "../Hooks/useForm";
import Form from "../FormUi/Form";
import useDataStore from "../Hooks/useDataStore";
import useFetchPost from "../Hooks/useFetchPost";

import DocumentsTable from "../Tables/DocumentsTable";
import moment2 from "moment-timezone";
import { Field } from "../Types/Form";
import { DocumentTypes, DocumentTypeTranslations } from "../enums/DocumentTypes";
import "../../css/Global.css";

import EditPersonalData from "../Profile/Details/EditPersonalData";

import { fetcherGET, fetcherPOSTJSON, fetcherPOST } from "../Common/Fetch";
import { IPersonalData } from "../Common/types";
import axios from "axios";
// данная модель используется для передечи через неё данных контроллеру и хранимой процедуре
// необходимо cтрого поддерживать соответвтие её полей классу Mithra.Data.Models.Catalog.CatalogModel
// так как этот класс сериализуется в json и передаётся на сервер, где его принимают в качетсве модели данных Mithra.Data.Models.Catalog.CatalogModel

import useGetPersonalAccountInfo from "../Api/useGetPersonalAccountInfo";
import Tooltip from "../Ui/Tooltip";
import UploadFilePopup from "../Popups/UploadFilePopup";
import AgentHelpPopup from "../Popups/AgentHelpPopup";
import usePostGetDocuments from "../Api/usePostGetDocuments";

import Table from "../Tables/Table";
import { FilterTypes } from "../enums/TableTypes";

function TestArea()
{
    const openPopupVideo = useSignal();
    const signalOpenVideo = "testVideoOpen";
    const signalSendVideo = "testVideoSend";
    const {mutate: getdocs, data: docs } = usePostGetDocuments(); 
    useEffect(() => { getdocs(null) }, [])

    const renderDocType = (rowData) => (
        DocumentTypeTranslations[rowData.DocumentTypeId]
    )

    const [cols, setcols] = useState([
        {
            name: "DocumentTypeId",
            title: "Тип документа",
            colWidth: "15%",
            body: renderDocType,
            filter: {
                init: true,
                type: FilterTypes.dropDown,
                options:
                    Object.keys(DocumentTypes)
                    .filter((key) => !isNaN(Number(key)))
                    .map((key) => ({
                        label: DocumentTypeTranslations[Number(key)],
                        value: Number(key)
                    }))
            }
        },
        {
            name: "Name",
            title: "Название",
            colWidth: "25%",
            filter: {
                init: true,
            }
        },
        { name: "Comment", title: "Комментарий", colWidth: "20%" },
    ])

    useSlot(signalSendVideo, (_: string, file: File) => {
        console.log("Получен видеофайл через слот:", file);
    });

    return (
        <React.Fragment>
            <div className="boxes">

                <div className="box" style={{ gridColumn: "1/span 2" }}>
                    <Table
                        data={docs}
                        columns={cols}
                    />
                </div>

                <div className="box" style={{ gridColumn: "1/span 2" }}>
                    <h4 className="purpleTextHead">Попап загрузки видео</h4>
                    <button
                        className="defaultPinkButton"
                        onClick={() => openPopupVideo(signalOpenVideo, true)}
                    >
                        Тестировать
                    </button>

                    <PopupLoadVideo
                        signalOpenPopup={signalOpenVideo}
                        signalSendFile={signalSendVideo}
                        textButtonSend="Загрузить видео"
                        description="Выберите видеофайл для загрузки (до 100MB)"
                    />

                    <div className="boxDescription">
                        <p className="defaultDescription">
                            Компонент для загрузки видеофайлов. Открывается по сигналу <code>{signalOpenVideo}</code>,
                            возвращает файл через сигнал <code>{signalSendVideo}</code> в виде объекта <code>File</code>.
                        </p>
                    </div>
                </div>


                <div className="box" style={{ gridColumn: "1/span 2" }}>
                    <PictureCropPopup
                        head={{ title: "Загрузите чек", description: "Чек" }}
                        getPicture={(pic) => {console.log(pic)}}
                    >
                        <button className="button">click</button>
                    </PictureCropPopup>
                </div>

                <div className="box" style={{ gridColumn: "1/span 2" }}>
                    <UploadFilePopup
                        getFile={(file) => { console.log(file) }}
                    >
                        <button>File</button>
                    </UploadFilePopup>
                </div>

                {/*<div className="box" style={{ gridColumn: "1/span 2" }}>*/}
                {/*    <button onClick={() => setIsOpen(true)}>open</button>*/}
                {/*    <Popup*/}
                {/*        isOpen={isOpen}*/}
                {/*        head={head}*/}
                {/*        close={() => { setIsFinally(false); setIsOpen(false) }}*/}
                {/*        body={renderBody()}*/}
                {/*        isFinally={isFinally}*/}
                {/*        actionButtons={[{ name: "bebe", action: () => { setIsFinally(true); setHead({title: "D", description: "DDD"}) }}]}*/}
                {/*    />*/}
                {/*</div>*/}
                
                {/*<div className="box" style={{ gridColumn: "1/span 2" }}>*/}
                {/*    {!result ? (*/}
                {/*        <Loading />*/}
                {/*    ) : (*/}
                {/*        <DocumentsTable*/}
                {/*            data={result.UpdatedItem}*/}
                {/*            getDocuments={() => { initializeFetchPost("DocumentApi/GetDocuments") }}*/}
                {/*            apiUrls={{ UploadDocument: "/DocumentApi/AddDocument" }}*/}
                {/*            Mode={1}*/}
                {/*            CanUploadFromAllDocs={false}*/}
                {/*        />*/}
                {/*    )}*/}
                {/*</div>*/}

                {/*<div className="box">*/}
                {/*    {fields2.map(field => */}
                {/*        <Input*/}
                {/*            field={field}*/}
                {/*            error={errors[field.name]}*/}
                {/*            onChange={handleChange}*/}
                {/*            value={values?.[field.name]}*/}
                {/*            onCancel={handleCancel}*/}
                {/*        />*/}
                {/*    )}*/}

                {/*    <button onClick={() => { getData(getDataHandle) }}>Get data</button>*/}
                {/*</div>*/}
                
                {/*<div className="box">*/}
                {/*    {result3 &&*/}
                {/*        <img src={URL.createObjectURL(result3)}></img>    */}
                {/*    }*/}
                {/*    <button onClick={() => setIsOpen3(true) }>Open</button>*/}
                {/*    <PictureCropPopup*/}
                {/*        isOpen={isOpen3}*/}
                {/*        close={() => setIsOpen3(false)}*/}
                {/*        head={{ title: "Изображение" }}*/}
                {/*        maxSize={2}*/}
                {/*        getPicture={(picture) => setResult3(picture)}*/}
                {/*    />*/}
                {/*</div>*/}

                {/*<div className="box">*/}

                {/*        <ApplicationPopup>*/}
                {/*            <button className="defaultPinkButton">Test</button>*/}
                {/*        </ApplicationPopup>*/}

                {/*</div>*/}

                {/*<div className="box popupLoadPictures">*/}
                {/*    <h4 className="purpleTextHead">Попап загрузки изображения</h4>*/}
                {/*    <PopupLoadPictures*/}
                {/*        signalOpenPopup1={'openPopup1'}*/}
                {/*        signalSendFile1={'sendFile1'}*/}
                {/*        signalSetTitle1={'setTitle1'}*/}
                {/*        signalSetButtonText={'setButtonText1'}*/}
                {/*    />*/}
                {/*    {data &&*/}
                {/*        <div className="data">*/}
                {/*            <p className="defaultDescription">Название файла: {data.name}</p>*/}
                {/*            <p className="defaultDescription">Размер: {(data.size / 1024 / 1024).toFixed(1)}МБ</p>*/}
                {/*            <p className="defaultDescription">Расширение файла: {data.type}</p>*/}
                {/*        </div>   */}
                {/*    }*/}
                {/*    <button className="defaultPinkButton"*/}
                {/*        onClick={() => { openPopup1('openPopup1', true); setTitle1('setTitle1', 'Выберите файл'); setButtonText('setButtonText1', 'Загрузить') }}*/}
                {/*    >*/}
                {/*        Тестировать*/}
                {/*    </button>*/}
                    
                {/*    <img className="overview" src="../../images/testPageImages/testPageImage1.png"></img>*/}

                {/*    <div className="boxDescription">*/}
                {/*        <p className="defaultDescription">*/}
                {/*            Данный компонент нужен для загрузки изображений, изображение можно загрузить*/}
                {/*            методом drag-n-drop, либо же просто кликнуть на поле и выбрать файл.*/}
                {/*            После выбора файла, если его размер меньше 2МБ, дается возможность редактировать*/}
                {/*            зону у картинки, после чего создается объект File.*/}
                {/*            Компонент принимает два сигнала:*/}
                {/*            'Open popup' - для открытия попапа;*/}
                {/*            'setTitle' - для установки заголовка сверху(не обязательно);*/}
                {/*            'SetButtonText' - для текста у кнопки после загрузки и редактирования картинки(не обязательно);*/}
                {/*            А так же отправляет готовый файл через слот sendFile, слот принимает только сам файл.*/}
                {/*        </p>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/*<div className="box">*/}
                {/*    <h4 className="purpleTextHead">Загрузка изображений</h4>*/}
                {/*    <ListPicturesLoader />*/}
                {/*    <div className="boxDescription">*/}
                {/*        <p className="defaultDescription">*/}
                {/*            Компонент для загрузки нескольких изображений, принимает массив с объектами картинок в пропсах(не обязательно)*/}
                {/*            после загрузки и редактирования изображения она добавляется в общий массив Pictures и выводится ниже, */}
                {/*            каждую из картинок можно сделать главной(поставить на индекс 0), либо же удалить. Каждый раз когда*/}
                {/*            изменяется массив Pictures - его получает родительский компонент через signal.*/}
                {/*        </p>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<div className="box" style={{ "grid-column": '1/span2' }}>*/}
                {/*    <h4 className="purpleTextHead">Таблица для обработки персональных данных пользователей</h4>*/}
                {/*    <UserDetailsTable users={users} />*/}

                {/*    <div className="boxDescription">*/}
                {/*        <p className="defaultDescription">*/}
                {/*            Для получения массива пользователей компонент: <br></br>*/}
                {/*            -Отправляет сигнал SignalGetData в который передается объект: <br></br>*/}
                {/*            page: номер активной страницы, <br></br>*/}
                {/*            countRecord: количество отображаемых строк на странице, <br></br>*/}
                {/*            SortField: поле сортировки, <br></br>*/}
                {/*            Filters: фильтры <br></br>*/}

                {/*            -После ждет ответ от сигнала SignalGetDataResult с объектом: <br></br>*/}
                {/*            Success: boolean,<br></br>*/}
                {/*            Error: текст,<br></br>*/}
                {/*            totalRecords: сколько всего пользователей найдено,<br></br>*/}
                {/*            UpdatedItem: массив с объектами пользователей<br></br>*/}
                            
                {/*            Возможности: <br></br>*/}
                {/*            -Каждую строку пользователя можно раскрыть и посмотреть данные о нём <br></br>*/}
                {/*            -У подтвержденных пользователей появляется соответствующая иконка справа-снизу <br></br>*/}
                {/*            -Пользователю можно отправить уведомление в действиях <br></br>*/}
                {/*            -Пользователя можно удалить <br></br>*/}
                {/*            -Компонент получается массив с объектами пользователей <br></br>*/}
                {/*        </p>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<div className="box">*/}
                {/*    <h4 className="purpleTextHead">Попап подтвреждения</h4>*/}
                {/*    <p className="defaultDescription">Результат: {result1}</p>*/}
                {/*    <button className="defaultPinkButton" onClick={test1}>Тест</button>*/}
                {/*    <ConfirmPopup*/}
                {/*        signalOpenPopup="openConfirm"*/}
                {/*        description="desc"*/}
                {/*        signalConfirm="confirmPopup1"*/}
                {/*    />*/}

                {/*    <div className="boxDescription">*/}
                {/*        <p className="defaultDescription">*/}
                {/*            Компонент для подтверждения действий.<br></br> */}
                {/*            Принимает три пропса:<br></br> */}
                {/*            -название сигнала для открытия попапа (получает boolean)<br></br> */}
                {/*            -название сигнала для описания <br></br> */}
                {/*            -название слота для получения true/false <br></br>*/}
                {/*        </p>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<div className="box">*/}
                {/*    <h4 className="purpleTextHead">Попап уведомления</h4>*/}
                {/*    <p className="defaultDescription">Результат: {result2}</p>*/}
                {/*    <button className="defaultPinkButton" onClick={test2}>Тест</button>*/}
                {/*    <NotificationPopup*/}
                {/*        signalOpenPopup="openNotification"*/}
                {/*        description="desc1"*/}
                {/*        signalSendText="notifPopup1" />*/}

                {/*    <div className="boxDescription">*/}
                {/*        <p className="defaultDescription">*/}
                {/*            Компонент для отправки уведомления. <br></br>*/}
                {/*            Принимает три пропса: <br></br>*/}
                {/*            -название сигнала для открытия попапа (получает boolean) <br></br>*/}
                {/*            -название сигнала для описания <br></br>*/}
                {/*            -название слота для получения текста <br></br>*/}

                {/*            !!! После получения текста нужно еще раз отправить первый сигнал <br></br>*/}
                {/*            !!! с bool = false (чтобы закрыть его) <br></br>*/}
                {/*        </p>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<div className="box" style={{ "grid-column": '1/span2' }}>*/}
                {/*    <PersonalDataTable data={personalData} />*/}
                {/*</div>*/}
                {/*<div className="box" style={{ "grid-column": '1/span2' }}>*/}
                {/*    <DocumentsTable />*/}
                {/*</div>*/}
            </div>
        </React.Fragment>
    );
}

export default TestArea;